import resolvePathname from '../resolve-pathname';
import valueEqual from '../value-equal';
import { parsePath } from './PathUtils';
export function createLocation(path, state, key, currentLocation) {
  let location;
  if (typeof path === 'string') {
    location = Object.assign({}, parsePath(path), {
      // @ts-expect-error state is S | undefined but Location requires S
      state
    });
  } else {
    var _path$pathname, _path$search, _path$hash;
    location = {
      pathname: (_path$pathname = path.pathname) !== null && _path$pathname !== void 0 ? _path$pathname : '',
      search: (_path$search = path.search) !== null && _path$search !== void 0 ? _path$search : '',
      hash: (_path$hash = path.hash) !== null && _path$hash !== void 0 ? _path$hash : '',
      state: state !== undefined && path.state === undefined ? state : path.state,
      key: path.key
    };
    if (location.search && location.search.charAt(0) !== '?') location.search = `?${location.search}`;
    if (location.hash && location.hash.charAt(0) !== '#') location.hash = `#${location.hash}`;
  }
  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError(`Pathname "${location.pathname}" could not be decoded. This is likely caused by an invalid percent-encoding.`);
    } else {
      throw e;
    }
  }
  if (key) location.key = key;
  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = resolvePathname(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }
  return location;
}
export function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && valueEqual(a.state, b.state);
}